
import React, { useState, useEffect } from "react";
import { Button, Container, Grid } from "@material-ui/core";
import HomePage from "../../Home";
import { VProveedorStyle } from "./styles";
import FProveedor from "./../FProveedores";
import TProveedor from "./../TProveedor";
import { useDispatch, useSelector } from "react-redux";
import { obtenerProveedoresAllAction } from "../../../ducks/proveedorDuck";
import BackDrop from "./../../../global/BackDrop";
export default function VProveedor() {
    const Clasess = VProveedorStyle();
    const dispatch = useDispatch();
    const proveedores = useSelector(store => store.proveedores.array);
    const [openModal, setOpenModal] = useState(false);
    const [rowTarget, setRowTarget] = useState({});
    const [editar, setEditar] = useState(false);
    const [isLoad, setIsLoad] = useState(false);
    useEffect(() => {
        setIsLoad(true);
        dispatch(obtenerProveedoresAllAction()).then((Reposne) => {
            setIsLoad(false);
        });
    }, [dispatch])

    const handleOpen = () => {
        setOpenModal(!openModal);
        setEditar(false);
    }
    const onEditar = (rowTarget) => {
        setRowTarget(rowTarget);
        setEditar(true);
        setOpenModal(!openModal);
    }
    return (
        <HomePage>
            <Container>
                <Grid container>
                    <Grid item xs={12} className={Clasess.contentMargin}>
                        <Button variant="outlined" color="primary" onClick={handleOpen}>Nuevo Proveedor</Button>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12}>
                        <TProveedor
                            rows={proveedores}
                            onEditar={onEditar}
                        />
                    </Grid>
                </Grid>
                <FProveedor
                    open={openModal}
                    setOpen={setOpenModal}
                    editar={editar}
                    setEditar={setEditar}
                    rowData={rowTarget}
                />
                <BackDrop open={isLoad} />
            </Container>
        </HomePage>
    );
}